import { render, staticRenderFns } from "./addPunteModal.vue?vue&type=template&id=206f4cb4"
import script from "./addPunteModal.vue?vue&type=script&lang=js"
export * from "./addPunteModal.vue?vue&type=script&lang=js"
import style0 from "./addPunteModal.vue?vue&type=style&index=0&id=206f4cb4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports